/* global gtag */
import React, { useEffect, useRef, useState, useCallback } from "react";
import Home from "./components/Home";
import QuestionTwo from "./components/Email";
import Health_goals from "./components/Health_goals";
import QuestionFour from "./components/QuestionFour";
import QuestionFive from "./components/QuestionFive";
import QuestionSix from "./components/QuestionSix";
import LastPage from "./components/LastPage";
import "../../App.css";
import QuestionSeven from "./components/QuestionSeven";
import QuestionEight from "./components/QuestionEight";
import QuestionNine from "./components/QuestionNine";
import PhoneNumber from "./components/PhoneNumber";
import Name from "./components/Name";
import Email from "./components/Email";
import { FaArrowLeft } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import Age from "./components/age";
import Gender from "./components/gender";
import Weight from "./components/weight";
import Height from "./components/height";
import { useWeightContext } from "./context/appContext.js";
import Questioneleven from "./components/questioneleven";
import QuestionTen from "./components/questionTen";
import Questiontwilve from "./components/questiontwilve";
import Question13 from "./components/Question13";
import axios from "axios";
// import Loader from "../../../../containers/loader.js";
import SLoader from "./components/loader";
import { apiUrl } from "../../config/config.js";
import HealthAssessment from "../../appUi.js";
// import OptVerification from "../containers/optVerification.js";
import { AiOutlineInfoCircle } from "react-icons/ai";
import HealthSpendProvider from "./context/appContext.js";
import Loader from "../../containers/loader.js";
import OptVerification from "../../containers/optVerification.js";
import QuestionFourteen from "./components/questionFourteen.js";
import QuestionFifteen from "./components/questionFifteen.js";
import QuestionSixteen from "./components/questionSixteen.js";
import { Link, useSearchParams } from "react-router-dom";
import { IoClose } from "react-icons/io5";

function App() {
  const [searchParams] = useSearchParams();

  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [setShowNote] = useState(false);
  const {
    payload,
    setPayload,
    currentPage,
    setCurrentPage,
    currentTab,
    setCurrentTab,
    skipquestion,
    loading,
    setLoading,
    sessionValue,
    // isPhoneVerified,
    // setIsPhoneVerified,
  } = useWeightContext();

  // console.log()

  const validatePersonalInfo = () => {
    const newErrors = {};
    const nameRegex = /^[a-zA-Z\s]{2,50}$/;
    // const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (!nameRegex.test(formData?.name)) {
      newErrors.name = "Please enter a valid full name";
    }
    if (!emailRegex.test(formData?.email)) {
      newErrors.email = "Please enter a valid email";
    }
    if (!phoneRegex.test(formData?.phone)) {
      newErrors.phone = "Please enter a valid phone number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Allow only numbers for phone input
    const newValue = name === "phone" ? value.replace(/[^0-9]/g, "") : value;
    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handleOptionSelect = (category, value) => {
    if (category === "goals") {
      setFormData((prev) => ({
        ...prev,
        goals: prev.goals.includes(value)
          ? prev.goals.filter((g) => g !== value)
          : [...prev.goals, value],
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [category]: value,
      }));
    }
  };
  // const progress = ((currentPage - 1) / (totalSteps - 1)) * 100;

  const totalSteps = 18; // Update this based on the total number of steps

  const progressPercentage = ((currentPage / totalSteps) * 100).toFixed(0);

  const [healthgoals, setHealthgoals] = useState(null);
  const [medicalcondition, setMedicationCondition] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [IsQuizStarted, setIsQuizStarted] = useState(true);

  const payloadRef = useRef();

  useEffect(() => {
    payloadRef.current = payload;
  }, [payload]);

  useEffect(() => {
    const hasValueIsTrue = () => {
      if (payload.health_goals) {
        return (
          payload.health_goals.includes("Bloating & Gas") ||
          payload.health_goals.includes("Constipation")
        );
      }
      return false;
    };

    const hasMedical_condition = () => payload.medical_condition === "Yes";
    const hasExercise = () => payload.exercise === "No";

    // console.warn("hasExercise", hasExercise());

    setHealthgoals(hasValueIsTrue());

    setPayload((prevData) => {
      let updatedData = { ...prevData };
      let needsUpdate = false;

      if (hasValueIsTrue() === false && prevData.gat_Symptom !== null) {
        updatedData.gat_Symptom = null;
        needsUpdate = true;
      } else if (
        hasMedical_condition() === false &&
        prevData.diagnosed_conditions.length > 0
      ) {
        updatedData.diagnosed_conditions = [];
        needsUpdate = true;
      } else if (
        hasExercise() === true &&
        prevData.phyiscal_activity !== "light"
      ) {
        updatedData.phyiscal_activity = "light";
        needsUpdate = true;
      }

      return needsUpdate ? updatedData : prevData;
    });
  }, [payload.health_goals, payload.medical_condition, payload.exercise]);

  useEffect(() => {
    const isStart = searchParams.get("isquizstart");
    if (isStart === "true") {
      window.gtag({
        event: "start_assessment_click",
        data: {
          event_category: "engagement",
          event_label: "start_your_free_assessment_button",
          value: 1,
        },
      });
      window.newtag("event", "new_start_assessment_click", {
        event_category: "engagement",
        event_label: "new_start_your_free_assessment_button",
        value: 1,
      });
      setIsQuizStarted(false);
    }
  }, [searchParams]);

  useEffect(() => {
    if (payload.exercise === "No") {
      setPayload((prevData) => ({ ...prevData, phyiscal_activity: "light" }));
    }
  }, [payload.exercise]);

  const PrevHandler = () => {
    setCurrentPage((prevPage) => {
      if (healthgoals === false && prevPage === 7) {
        return prevPage - 2;
      } else if (
        payloadRef.current.medical_condition === "No" &&
        prevPage === 12
      ) {
        return prevPage - 2;
      } else if (payloadRef.current.exercise === "No" && prevPage === 9) {
        return prevPage - 2;
      } else {
        return prevPage - 1;
      }
    });
  };

  const HandleNext = (pageValue, pageName) => {
    setPayload((prevData) => ({ ...prevData, [pageName]: pageValue }));
    setCurrentPage((prevPage) => {
      if (pageName === "medical_condition" && pageValue === "No") {
        return prevPage + 2;
      } else if (pageName === "exercise" && pageValue === "No") {
        return prevPage + 2;
      } else {
        return prevPage + 1;
      }
    });

    const newPayload = {
      ...payload,
      [pageName]: pageValue,
    };

    const data = {
      sessionId: sessionValue,
      formData: newPayload,
    };

    const config = {
      method: "post",
      url: `${apiUrl}/api/v1/session/update`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        // console.log("Session updated successfully:", response.data);
      })
      .catch((error) => {
        console.error("Failed to update session:", error);
      });
  };

  const FirstNextHandle = (e) => {
    e.preventDefault();
    if (!validatePersonalInfo()) {
      return;
    }
    setPayload((prevData) => ({
      ...prevData,
      name: formData?.name,
      email: formData?.email,
      phone: formData?.phone,
    }));
    setCurrentPage((prevPage) => prevPage + 1);
    setFormData({});

    const sessionCreate = async () => {
      try {
        const config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${apiUrl}/api/v1/session/create`,
          headers: {},
        };

        const response = await axios.request(config);
        if (response.data.success === true) {
          const sessionId = response.data.sessionId;
          sessionStorage.setItem("quiz_Id", sessionId);
          updateSession(sessionId);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const updateSession = async (sessionId) => {
      try {
        const newPayload = {
          ...payload,
          name: formData?.name,
          email: formData?.email,
          phone: formData?.phone,
        };
        const data = {
          sessionId: sessionId,
          formData: newPayload,
        };

        const config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${apiUrl}/api/v1/session/update`,
          headers: {},
          data: data,
        };

        await axios.request(config);
        // Handle successful response
      } catch (error) {
        console.log(error);
      }
    };

    sessionCreate();
    gtag({
      event: "personal_info",
      data: {
        name: formData?.name,
        email: formData?.email,
        phone: formData?.phone,
      },
    });
  };

  // //codeBy Shubham Sharma
  // useEffect(() => {
  //   const sessionCreate = async () => {
  //     try {
  //       const config = {
  //         method: "post",
  //         maxBodyLength: Infinity,
  //         url: `${apiUrl}/api/v1/session/create`,
  //         headers: {},
  //       };

  //       const response = await axios.request(config);
  //       if (response.data.success === true) {
  //         const sessionId = response.data.sessionId;
  //         sessionStorage.setItem("quiz_Id", sessionId);
  //         // updateSession(sessionId);
  //       }
  //       return sessionStorage
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  //   const updateSession = async (updateData, sessionId) => {

  //     console.log("sessionId 315",sessionId);
  //     try {
  //       const newPayload = {
  //         ...payload,
  //         name: updateData?.name,
  //         email: updateData?.email,
  //         phone: updateData?.phone,
  //       };
  //       const data = {
  //         sessionId: sessionId,
  //         formData: newPayload,
  //       };

  //       const config = {
  //         method: "post",
  //         maxBodyLength: Infinity,
  //         url: `${apiUrl}/api/v1/session/update`,
  //         headers: {},
  //         data: data,
  //       };

  //       await axios.request(config);
  //       // Handle successful response
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  //   const urlParams = new URLSearchParams(window.location.search);
  //   const name = urlParams.get("name");
  //   const email = urlParams.get("email");
  //   const phone = urlParams.get("phone");

  //   if (name && email && phone) {
  //     let sessionId = await sessionCreate();
  //     let payload = {name: name, email: email, phone: phone}
  //     // setFormData({ name, email, phone });
  //     // HandleNext(1, "age");
  //     setCurrentPage(1);
  //     setIsQuizStarted(false);
  //     console.log("sessionId",sessionId);
  //     updateSession(payload ,sessionId);
  //   }
  // }, []);

  // Code by Shubham Sharma

  const sessionCreate = async () => {
    try {
      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/v1/session/create`,
        headers: {},
      };

      const response = await axios.request(config);
      if (response.data.success === true) {
        const sessionId = response.data.sessionId;
        sessionStorage.setItem("quiz_Id", sessionId);
        return sessionId;
      }
    } catch (error) {
      console.error("Error creating session:", error);
    }
    return null; // Return null if session creation fails
  };

  const updateSession = async (updateData, sessionId) => {
    if (!sessionId) {
      console.error("Session ID is required to update session.");
      return;
    }

    try {
      // const newPayload = {
      //   name: updateData?.name,
      //   email: updateData?.email,
      //   phone: updateData?.phone,
      // };
      const newPayload = {
        ...payload,
        name: updateData?.name,
        email: updateData?.email,
        phone: updateData?.phone,
      };

      const data = {
        sessionId: sessionId,
        formData: newPayload,
      };

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/v1/session/update`,
        headers: {},
        data: data,
      };

      await axios.request(config);
      // console.log("Session updated successfully.");
    } catch (error) {
      console.error("Error updating session:", error);
    }
  };

  useEffect(() => {
    const initializeSession = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const name = urlParams.get("name");
      const email = urlParams.get("email");
      const phone = urlParams.get("phone");

      if (name && email && phone) {
        const sessionId = await sessionCreate();
        if (sessionId) {
          const payload = { name, email, phone };

          setPayload((prevData) => ({
            ...prevData,
            ["name"]: name,
            ["email"]: email,
            ["phone"]: phone,
          }));
          await updateSession(payload, sessionId);
          setCurrentPage(1);
          setIsQuizStarted(false);
          // console.log("Session ID:", sessionId);
        } else {
          console.error("Failed to create session.");
        }
      }
    };

    initializeSession();
  }, []);

  // console.log("page ==>", currentPage);
  // console.log("formdata ==>", formData);
  // console.log("IsQuizStarted ==>", IsQuizStarted);
  // console.log("payload ==>", payload);

  // console.warn("==>", currentPage);
  // console.log("==>", payload);

  const FinishHandler = () => {
    const sesssionPayload = {
      sessionId: sessionValue,
    };
    try {
      setLoading(true);
      setIsLoading(true);
      let sessionConfig = {
        method: "delete",
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/v1/session/delete`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(sesssionPayload),
      };

      axios.request(sessionConfig).then((response) => {
        // console.log(JSON.stringify("Session Delete", response.data));
        sessionStorage.removeItem("quiz_Id");
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/v1/diagnose/create`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
      };

      // console.log(JSON.stringify(payload));
      axios
        .request(config)
        .then((response) => {
          // console.log(JSON.stringify("response.data", response.data.data._id));
          setIsLoading(true);
          if (response.data.success === true && response.data?.data._id) {
            window.location.href = `https://thehealthspanco.com/pages/report?healthspanid=${response.data?.data?._id}`;
            setCurrentPage(0);
            setPayload([]);
          } else {
            setLoading(false);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          setIsLoading(false);

          console.log(error);
        });
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const [isOtpSended, setIsOtpSended] = useState("");
  const [showOpt, setShowOpt] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(true);

  const [optLoader, setOptLoader] = useState(false);
  const OtpHandler = (e) => {
    e.preventDefault();
    if (!isOtpVerified) {
      setOptLoader(true);
      if (formData.phone.length === 10) {
        let data = JSON.stringify({
          phone: formData?.phone,
        });

        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${apiUrl}/api/v1/whatsapp/sendotp`,
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };

        axios
          .request(config)
          .then((response) => {
            // console.log(JSON.stringify(response.data));
            if (response.data.success) {
              // setTimeout(() => {
              setIsOtpSended(true);
              setShowOpt(true);
              setOptLoader(false);
              // }, 4000);
            } else {
              setOptLoader(false);
              setIsOtpSended(false);
            }
          })
          .catch((error) => {
            setOptLoader(false);
            console.log(error);
          });
      }
    }
  };

  const Header = () => (
    // <div className="flex  w-full  justify-center items-center relative py-3  bg-[#2d3d23] text-white">
    <div className="flex  w-full  justify-center items-center relative py-3  bg-[#20606D] text-white">
      <div className="w-11/12 relative gap-2  flex items-center justify-center ">
        {/* logo */}
        <img
          alt={`The Healthspan Co`}
          title={`The Healthspan Co`}
          loading="eager"
          fetchPriority="high"
          width={130}
          height={50}
          src={`https://thehealthspanco.com/cdn/shop/files/Logo_280x100px.png?v=1706525837&width=240`}
          className={` w-24 lg:w-32   brightness-[15000%] cursor-pointer`}
          onClick={() => {
            window.location.href = "https://thehealthspanco.com/";
          }}
        />
        {/* <div className=' text-sm lg:text-base'>Weight & Waist Assessment.</div> */}
      </div>
    </div>
  );

  // console.log("currentPage", formData);
  return !IsQuizStarted ? (
    <div className="App gap-10 ">
      {isLoading && <Loader />}
      {/* {!isOtpSended && ( */}
      {/* {showOpt && (
        <div className="fixed w-full h-full z-50 flex justify-center items-center">
          <div className=" absolute w-full h-full backdrop-blur"></div>

          <div
            className="p-4 fixed top-1/2 z-50 left-1/2 -translate-x-1/2 -translate-y-1/2 mb-4 text-sm w-11/12 md:w-5/12 max-w-2xl flex flex-col justify-center items-center bg-white border-t-4 border-[#2F412F] drop-shadow-lg shadow-lg rounded-lg "
            role="alert"
          >
            <div className="text-[#2F412F] text-sm font-bold mb-2">
              The HealthSpan Co.
            </div>
            <div className="font-bold text-[#2F412F] text-3xl mb-10">
              Otp Verification
            </div>
            <OptVerification
              formData={formData}
              setShowOpt={setShowOpt}
              setIsOtpVerified={setIsOtpVerified}
              OtpHandler={OtpHandler}
            />
          </div>
        </div>
      )} */}

      {showOpt && (
        <div
          className="fixed w-full h-full z-50 flex justify-center items-center"
          onClick={() => setShowOpt(false)} // Close on background click
        >
          <div
            className="absolute w-full h-full backdrop-blur"
            onClick={() => setShowOpt(false)} // Fallback click on blur
          ></div>

          <div
            className="p-4 fixed top-1/2 z-50 left-1/2 -translate-x-1/2 -translate-y-1/2 mb-4 text-sm w-11/12 md:w-5/12 max-w-2xl flex flex-col justify-center items-center bg-white border-t-4 border-[#2F412F] drop-shadow-lg shadow-lg rounded-lg"
            role="alert"
            onClick={(e) => e.stopPropagation()} // Prevent close when clicking inside
          >
            {/* Cross Button */}
            <button
              className="absolute top-2 right-2 text-[#2F412F] hover:bg-[#2F412F] hover:text-white p-1 rounded-md transition-colors duration-300 ease-in-out"
              onClick={() => setShowOpt(false)}
            >
              <IoClose />
            </button>

            <div className="text-[#2F412F] text-sm font-bold mb-2">
              The HealthSpan Co.
            </div>
            <div className="font-bold text-[#2F412F] text-3xl mb-10">
              Otp Verification
            </div>
            <OptVerification
              formData={formData}
              setShowOpt={setShowOpt}
              setIsOtpVerified={setIsOtpVerified}
              OtpHandler={OtpHandler}
            />
          </div>
        </div>
      )}

      {/* )} */}

      <div className="h-screen relative w-full bg-gray-100 overflow-y-auto ">
        {/* Header */}
        {/* <header className="bg-[#2F412F] sticky h-24 top-0 z-50 p-5 flex justify-between items-center"> */}
        <header className="bg-[#20606D] sticky h-24 top-0 z-50 p-5 flex justify-between items-center">
          {/* <div className="text-white text-lg md:text-2xl font-bold">
            The HealthSpan Co.
          </div> */}
          <Link to="https://thehealthspanco.com/" className="logo" id="logo">
            <img
              title={`The Healthspan Co`}
              loading="eager"
              fetchPriority="high"
              width={170}
              height={50}
              src="/whiteLogo.webp"
              alt="The HealthSpan Co."
              className="h-10 md:h-12 object-contain"
            />
          </Link>
          <button
            onClick={() => {
              setCurrentPage(0);
              setPayload("");
              window.location.href = "https://thehealthspanco.com/";
            }}
            id="exit"
            className="bg-white px-4 text-xs md:text-base p-1 md:py-2 rounded text-red-600 no-underline"
          >
            Exit
          </button>
        </header>

        {/* <div className="max-w-4xl mx-auto p-5 h-[calc(100%-6rem)]  "> */}
        <div className="max-w-4xl mx-auto p-5 h-auto ">
          <div className="hidden rounded-xl overflow-hidden">
            {/* Desktop image (shown on md and up) */}
            <img
              title={`The Healthspan Co`}
              loading="eager"
              fetchPriority="high"
              width={1200}
              height={600}
              src="/images/Desktop banner_top_New.png"
              className="w-full h-auto object-cover hidden md:block"
              alt="Desktop Banner"
            />

            {/* Mobile image (shown below md) */}
            <img
              title={`The Healthspan Co`}
              loading="eager"
              fetchPriority="high"
              width={600}
              height={400}
              src="/images/Mobile banner_top_New.png"
              className="w-full h-auto object-cover block md:hidden"
              alt="Mobile Banner"
            />
          </div>
          {/* Progress Bar */}
          <div className="my-5">
            <div className="h-1.5 bg-gray-200 rounded overflow-hidden">
              <div
                className="h-full bg-[#FFB74D] transition-all duration-500"
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
            <div className="flex gap-1.5 md:gap-2.5 mt-2.5 overflow-auto">
              {[
                "Personal Info",
                "Goals",
                "Movement",
                window.innerWidth > 768 ? "Diet & Health" : "Diet",
                "Results",
              ]
                .filter((step, index) => window.innerWidth > 768 || index !== 4)
                .map((step, index) => (
                  <div
                    key={step}
                    className={`flex-1 p-2 md:p-4 text-xs text-nowrap md:text-base text-center rounded-lg cursor-pointer transition-all
                  ${
                    (currentPage <= 4 && step === "Personal Info") ||
                    (currentPage >= 5 &&
                      currentPage <= 6 &&
                      step === "Goals") ||
                    (currentPage >= 7 &&
                      currentPage <= 9 &&
                      step === "Movement") ||
                    (currentPage >= 10 &&
                      currentPage <= 14 &&
                      (step === "Diet & Health" || step === "Diet")) ||
                    (currentPage === 15 && step === "Results")
                      // ? "bg-[#2F412F] text-white"
                      ? "bg-[#20606D] text-white"
                      : "bg-white"
                  }`}
                  >
                    {step}
                  </div>
                ))}
            </div>
          </div>
          {currentPage === 0 && (
            <form className="h-full">
              <div className="bg-white rounded-xl p-8 shadow-md">
                <div className="animate-fadeIn text-start">
                  <Heading
                    title="It only takes 2 minutes — Get Started Now!"
                    description="Tell us a bit about yourself"
                  />

                  <div className="space-y-6">
                    <InputField
                      label="Full Name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      error={errors.name}
                      id="name"
                    />

                    <InputField
                      label="Email Address"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      error={errors.email}
                      id="email"
                    />

                    <div>
                      <div className="flex items-start  gap-2 w-full">
                        <div className="w-full flex flex-col items-start">
                          <InputField
                            label="Mobile Number"
                            name="phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                            error={errors.phone}
                            className="w-full"
                            disabled={!isOtpVerified}
                            maxLength={10}
                            id="phone"
                          />
                          {/* <div className="hidden sm:text-sm mt-2 sm:flex items-center gap-2 bg-yellow-50 text-yellow-600 rounded px-2">
                            <AiOutlineInfoCircle className=" text-xs sm:text-base" />
                            <span>
                              Hi, we'll whatsapp you an OTP right away, to be
                              sure that BOTs don't take our assessment.
                            </span>
                          </div> */}
                        </div>

                        {/* <div
                          className={`text-nowrap border sm:mt-7 mt-5 sm:py-3 sm:px-3 py-2 px-2 rounded-lg  ${
                            isOtpVerified
                              ? "bg-transparent text-[#2F412F]"
                              : "border-2 border-[#2F412F] text-[#2F412F] cursor-pointer"
                          }`}
                          onClick={formData.phone && OtpHandler}
                        >
                          {isOtpVerified ? (
                            "Verified"
                          ) : (
                            <span className="relative text-sm">
                              <span
                                className={`${
                                  optLoader ? "opacity-100" : "opacity-0"
                                } absolute w-10/12 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 z-10`}
                              >
                                <SLoader />
                              </span>
                              <span
                                className={`${
                                  optLoader ? "opacity-0" : "opacity-100"
                                }`}
                              >
                                Send Otp
                              </span>
                            </span>
                          )}
                        </div> */}
                      </div>
                      <div className="text-[0.59rem] sm:text-sm mt-2 sm:hidden flex items-center gap-2 bg-yellow-50 text-yellow-600 rounded px-2">
                        <AiOutlineInfoCircle className=" text-sm sm:text-base" />
                        <span>
                          Hi, we'll whatsapp you an OTP right away, to be sure
                          that BOTs don't take our assessment.
                        </span>
                      </div>
                    </div>
                  </div>

                  <NoteContainer
                    message="Your information is protected and will never be shared."
                    title="Privacy Guaranteed"
                  />
                </div>
              </div>
              <div className="flex justify-start my-8 w-full text-xs md:text-base">
                {isOtpVerified &&
                  (formData.name || formData.email || formData.phone) && (
                    <button
                      onClick={FirstNextHandle}
                      type="submit"
                      className="px-6 py-3 bg-[#2F412F] text-white rounded-lg font-semibold ml-auto hover:bg-[#3D533D] transition-colors"
                    >
                      Continue
                    </button>
                  )}
              </div>
            </form>
          )}
          {currentPage === 1 && (
            <Age
              onNext={(data) => HandleNext(data, "age")}
              onPrev={() => {
                PrevHandler();
                setIsOtpVerified(false);
              }}
            />
          )}
          {currentPage === 2 && (
            <Gender
              onNext={(data) => HandleNext(data, "gender")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 3 && (
            <Weight
              onNext={(data) => HandleNext(data, "weight")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 4 && (
            <Height
              onNext={(data) => HandleNext(data, "height")}
              onPrev={PrevHandler}
              // onClick={SessionUpdateHandler}
            />
          )}
          {currentPage === 5 && (
            <Health_goals
              onNext={(data) => HandleNext(data, "health_goals")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 6 && (
            <QuestionFour
              onNext={(data) => HandleNext(data, "gat_Symptom")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 7 && (
            <QuestionFive
              onNext={(data) => HandleNext(data, "exercise")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 8 && (
            <QuestionSeven
              onNext={(data) => HandleNext(data, "phyiscal_activity")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 9 && (
            <QuestionEight
              onNext={(data) => HandleNext(data, "sleep")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 10 && (
            <QuestionNine
              onNext={(data) => HandleNext(data, "medical_condition")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 11 && (
            <QuestionTen
              onNext={(data) => HandleNext(data, "diagnosed_conditions")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 12 && (
            <Questioneleven
              onNext={(data) => HandleNext(data, "eating_habits")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 13 && (
            <Questiontwilve
              onNext={(data) => HandleNext(data, "allergic")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 14 && (
            <Question13
              onNext={(data) => HandleNext(data, "medication")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 15 && (
            <QuestionFourteen
              onNext={(data) => HandleNext(data, "already_tried")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 16 && (
            <QuestionFifteen
              onNext={(data) => HandleNext(data, "personalized_plan")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 17 && (
            <QuestionSixteen
              onNext={(data) => HandleNext(data, "blood_test_url")}
              onPrev={PrevHandler}
            />
          )}
          {currentPage === 18 && (
            <LastPage onFinish={(data) => FinishHandler(data)} />
          )}{" "}
          {/* {currentPage === 6 && (
            <div className="animate-fadeIn">
              <Heading
                title="Your Health Goals"
                description="Select all that apply to personalize your journey"
              />

              <div className="grid gap-4">
                {[
                  {
                    id: "weight",
                    title: "Weight Management",
                    desc: "Achieve and maintain a healthy weight",
                  },
                  {
                    id: "energy",
                    title: "Energy Boost",
                    desc: "Improve daily energy levels",
                  },
                  {
                    id: "strength",
                    title: "Build Strength",
                    desc: "Increase muscle tone and strength",
                  },
                  {
                    id: "sleep",
                    title: "Better Sleep",
                    desc: "Improve sleep quality and patterns",
                  },
                ].map((goal) => (
                  <CheckContainer
                    key={goal.id}
                    goal={goal}
                    formData={formData}
                    handleOptionSelect={handleOptionSelect}
                    category="goals"
                  />
                ))}
              </div>
              {
                <NoteContainer
                  message="Setting specific, measurable health goals increases your chances of success by up to 95%"
                  title="Did you know?"
                />
              }
            </div>
          )} */}
          {/* {currentPage === 100 && (
            <div className="animate-fadeIn">
              <Heading
                title="Physical Activity Level"
                description="Select your typical activity level"
              />

              <div className="grid gap-4">
                {[
                  {
                    id: "light",
                    title: "Light Activity",
                    desc: "Walking, light stretching, casual activities",
                  },
                  {
                    id: "moderate",
                    title: "Moderate Activity",
                    desc: "Brisk walking, yoga, dancing, active lifestyle",
                  },
                  {
                    id: "high",
                    title: "High Activity",
                    desc: "Running, intense workouts, competitive sports",
                  },
                ].map((activity) => (
                  <CheckContainer
                    key={activity.id}
                    goal={activity}
                    formData={formData}
                    handleOptionSelect={handleOptionSelect}
                    category="activity"
                  />
                ))}
              </div>
            </div>
          )} */}
          {/* {currentPage === 100 && (
            <div className="animate-fadeIn">
              <Heading
                title="Diet & Health"
                description="Tell us about your eating habits"
              />

              <div className="grid gap-4">
                {[
                  {
                    id: "balanced",
                    title: "Balanced Diet",
                    desc: "Mix of all food groups",
                  },
                  {
                    id: "vegetarian",
                    title: "Vegetarian",
                    desc: "Plant-based with dairy and eggs",
                  },
                  {
                    id: "vegan",
                    title: "Vegan",
                    desc: "Completely plant-based",
                  },
                ].map((diet) => (
                  <CheckContainer
                    key={diet.id}
                    goal={diet}
                    formData={formData}
                    handleOptionSelect={handleOptionSelect}
                    category="diet"
                  />
                ))}
              </div>
            </div>
          )} */}
          {/* {currentPage === 50 && (
            <div className="text-center p-5 md:p-10 animate-fadeIn">
              <div className="w-20 h-20 bg-[#2F412F] rounded-full flex items-center justify-center text-white text-4xl mx-auto mb-5">
                ✓
              </div>
              <h2 className="text-lg md:text-2xl font-bold mb-4">
                Your Assessment is Complete!
              </h2>
              <p className="mb-6 text-sm md:text-base">
                We've analyzed your responses and created a personalized health
                plan.
              </p>
              <a
                // href="thc-result.html"
                className="inline-block text-xs  md:text-base bg-[#2F412F] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#3D533D] transition-colors"
              >
                View Your Results
              </a>
            </div>
          )} */}
          {/* Navigation Buttons */}
          {/* {currentPage < totalSteps && (
            <div className="flex justify-between mt-8 text-xs md:text-base">
              {currentPage > 1 && (
                <button
                  onClick={handleBack}
                  className="px-6 py-3 bg-gray-100 rounded-lg font-semibold"
                >
                  Previous
                </button>
              )}
              <button
                onClick={handleNext}
                className="px-6 py-3 bg-[#2F412F] text-white rounded-lg font-semibold ml-auto hover:bg-[#3D533D] transition-colors"
              >
                Continue
              </button>
            </div>
          )} */}
          <div className="hidden rounded-xl overflow-hidden">
            {/* Desktop image (shown on md and up) */}
            <img
              title={`The Healthspan Co`}
              loading="lazy"
              fetchPriority="low"
              width={1200}
              height={600}
              src="/images/Desktop banner_bottom_New.png"
              className="w-full h-auto object-cover hidden md:block"
              alt="Desktop Banner"
            />

            {/* Mobile image (shown below md) */}
            <img
              title={`The Healthspan Co`}
              loading="lazy"
              fetchPriority="low"
              width={600}
              height={400}
              src="/images/Mobile banner_bottom_New.png"
              className="w-full h-auto object-cover block md:hidden"
              alt="Mobile Banner"
            />
          </div>
        </div>

        <div className="fixed bottom-4 right-4 z-50">
          <a
            href="https://api.whatsapp.com/send/?phone=918431335947&text=Hi%2C%0AI%27m+interested+in+learning+more+about+your+health+products+and+weight+loss+plan.&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-16 h-16 md:w-20 md:h-20"
          >
            <img
              alt="Chat on WhatsApp"
              title="Chat on WhatsApp"
              loading="eager"
              fetchPriority="high"
              width={65}
              height={65}
              src="/whatsappLogo.png"
              className="w-full h-full object-contain"
            />
          </a>
        </div>
      </div>
      {/* <HealthAssessment /> */}

      {/* {currentPage === 0 && (
        <Name onNext={(data) => HandleNext(data, "name")} />
      )}

      

      {currentPage === 1 && (
        <PhoneNumber onNext={(data) => HandleNext(data, "phone")} />
      )}
      {currentPage === 2 && (
        <Email
          onNext={(data) => HandleNext(data, "email")}
          // onClick={SessionUpdateHandler}
        />
      )}
      {currentPage === 3 && <Age onNext={(data) => HandleNext(data, "age")} />}
      {currentPage === 4 && (
        <Gender onNext={(data) => HandleNext(data, "gender")} />
      )}
      {currentPage === 5 && (
        <Weight onNext={(data) => HandleNext(data, "weight")} />
      )}
      {currentPage === 6 && (
        <Height
          onNext={(data) => HandleNext(data, "height")}
          // onClick={SessionUpdateHandler}
        />
      )}
      {currentPage === 7 && (
        <Health_goals onNext={(data) => HandleNext(data, "health_goals")} />
      )}
      {currentPage === 8 && (
        <QuestionFour onNext={(data) => HandleNext(data, "gat_Symptom")} />
      )}
      {currentPage === 9 && (
        <QuestionFive onNext={(data) => HandleNext(data, "exercise")} />
      )}
      {currentPage === 10 && (
        <QuestionSeven
          onNext={(data) => HandleNext(data, "phyiscal_activity")}
        />
      )}
      {currentPage === 11 && (
        <QuestionEight onNext={(data) => HandleNext(data, "sleep")} />
      )}
      {currentPage === 12 && (
        <QuestionNine
          onNext={(data) => HandleNext(data, "medical_condition")}
        />
      )}
      {currentPage === 13 && (
        <QuestionTen
          onNext={(data) => HandleNext(data, "diagnosed_conditions")}
        />
      )}
      {currentPage === 14 && (
        <Questioneleven onNext={(data) => HandleNext(data, "eating_habits")} />
      )}
      {currentPage === 15 && (
        <Questiontwilve onNext={(data) => HandleNext(data, "allergic")} />
      )}
      {currentPage === 16 && (
        <Question13 onNext={(data) => HandleNext(data, "medication")} />
      )}
      {currentPage === 17 && (
        <LastPage onFinish={(data) => FinishHandler(data)} />
      )} */}
    </div>
  ) : (
    <LandingPage setIsQuizStarted={setIsQuizStarted} Header={Header} />
  );
}

export default App;

export const InputField = ({
  label,
  name,
  value,
  onChange,
  error,
  className,
  id,
  ...props
}) => {
  return (
    <div className="w-full">
      <label
        className="block mb-1 text-xs md:text-base font-medium text-zinc-700"
        for={id}
      >
        {label}
      </label>
      <input
        type="text"
        name={name}
        value={value}
        onChange={onChange}
        className={`w-full p-2.5 text-sm md:text-lg px-5 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-[#2F412F] ${className}`}
        placeholder={`Enter your ${label}`}
        id={id}
        {...props}
      />
      {error && <span className="text-red-600 text-sm mt-1">{error}</span>}
    </div>
  );
};

export const Heading = ({ title, description }) => {
  return (
    <div className="text-start">
      <h2 className="text-lg md:text-2xl font-bold md:mb-2">{title}</h2>
      <p className="text-gray-600 mb-6 text-xs md:text-base">{description}</p>
    </div>
  );
};

const CheckContainer = ({ goal, formData, handleOptionSelect, category }) => {
  return (
    <div
      key={goal.id}
      onClick={() => handleOptionSelect(category, goal.id)}
      className={`p-5 rounded-lg cursor-pointer transition-all text-start
                      ${
                        formData[category]?.includes(goal.id)
                          ? "bg-[#3D533D] text-white border-2 border-transparent"
                          : "bg-gray-100 hover:border-[#2F412F] border-2 border-transparent"
                      }`}
    >
      <div className="font-semibold mb-1 md:mb-3 text-sm md:text-lg">
        {goal.title}
      </div>
      <div className="text-xs md:text-base opacity-90 ">{goal.desc}</div>
    </div>
  );
};

const NoteContainer = ({ message, title }) => {
  return (
    <div className="bg-orange-50 border-l-4 border-[#FFB74D] p-4 rounded mt-6 text-xs md:text-lg text-start">
      <strong className="">{title}:</strong> {message}
    </div>
  );
};

const LandingPage = ({ setIsQuizStarted, Header }) => {
  const quizStarted = () => {
    window.dataLayer.push({
      event: "assesment_start",
      event_label: "start_quiz_button",
      value: "quiz started",
    });
    console.log("window", window.dataLayer);
  };
  return (
    <>
      <div className="fixed bottom-4 right-4 z-50">
        <a
          href="https://api.whatsapp.com/send/?phone=918431335947&text=Hi%2C%0AI%27m+interested+in+learning+more+about+your+health+products+and+weight+loss+plan.&type=phone_number&app_absent=0"
          target="_blank"
          rel="noopener noreferrer"
          className="block w-16 h-16 md:w-20 md:h-20"
        >
          <img
            alt="Chat on WhatsApp"
            title="Chat on WhatsApp"
            loading="eager"
            fetchPriority="high"
            width={65}
            height={65}
            src="/whatsappLogo.png"
            className="w-full h-full object-contain"
          />
        </a>
      </div>
      <div className="h-screen flex flex-col items-center  relative  text-center w-full backdrop-blur-lg ">
        <Header />
        <div className="container md:w-[70%] p-4 bg-white">
          {/* <header className="bg-gradient-to-r p-6 bg-[#2d3d23] text-white text-center py-12 rounded-b-2xl shadow-lg"> */}
          <header className="bg-gradient-to-r p-6 bg-[#20606D] text-white text-center py-12 rounded-b-2xl shadow-lg">
            <h1 className="text-3xl md:text-5xl font-bold mb-4">
              Discover Your Path to Sustainable Weight Management
            </h1>
            <p className="text-md md:text-xl opacity-90">
              Take our science-backed 2-minute quiz to know your current BMI,
              Ideal Weight and right calorie intake.
            </p>
          </header>

          <main>
            <div className="flex flex-col md:flex-row justify-center gap-8 my-8">
              <div className="text-center">
                {/* <div className="text-4xl font-bold text-[#2d3d23]">75,000+</div> */}
                <div className="text-4xl font-bold text-[#20606D]">75,000+</div>
                <div>Happy Customers</div>
                {/* <div>Success Stories</div> */}
              </div>
              <div className="text-center">
                {/* <div className="text-4xl font-bold text-[#2d3d23]">83%</div> */}
                {/* <div className="text-4xl font-bold text-[#2d3d23]">86%</div> */}
                <div className="text-4xl font-bold text-[#20606D]">86%</div>
                <div>Success Rate</div>
              </div>
              <div className="text-center">
                {/* <div className="text-4xl font-bold text-[#2d3d23]">2 min</div> */}
                <div className="text-4xl font-bold text-[#20606D]">2 min</div>
                <div>Quick Assessment</div>
              </div>
            </div>

            <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 my-8">
              {[
                {
                  imgSrc: "/QuizPageImageStep.jpg",
                  title: "Step 1",
                  // text: "Take the <strong>2-minute</strong> Weight Quiz",
                  text: "Take our <strong>2-minute</strong> Weight Quiz",
                },
                {
                  imgSrc: "assets/s2.png",
                  title: "Step 2",
                  // text: "Know the <strong>root cause</strong> of your weight gain and <strong>ideal weight</strong>",
                  text: "Know your <strong>BMI, ideal weight, </strong> and right <strong>calorie intake</strong>",
                },
                {
                  imgSrc: "assets/s3.png",
                  title: "Step 3",
                  // text: "Get <strong>personalised</strong> product recommendations",
                  text: "Get <strong>personalised</strong> 1:1 consultation with our expert nutritionist",
                },
                {
                  imgSrc: "assets/s4.png",
                  title: "Step 4",
                  // text: "Get a <strong>10-minute</strong> free consultation",
                  text: "Discover the <strong>science-backed</strong> supplements that are right for you",
                },
              ].map((benefit, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-lg shadow transition-transform transform hover:translate-y-1"
                >
                  <img
                    src={benefit.imgSrc}
                    alt={`Benefit ${index + 1}`}
                    title={`Benefit ${index + 1}`}
                    loading={index < 1 ? "eager" : "lazy"}
                    fetchPriority={index < 1 ? "high" : "low"}
                    width={350}
                    height={224}
                    className="h-56 w-full object-cover rounded-lg"
                  />
                  <div className="text-center mt-4 md:mt-8">
                    <h4 className="font-semibold mb-4 md:mb-7">
                      {benefit.title}
                    </h4>
                    <p dangerouslySetInnerHTML={{ __html: benefit.text }}></p>
                  </div>
                </div>
              ))}
            </section>

            <div
              // className="sticky bottom-5 text-center mb-8 cursor-pointer inline-block bg-orange-600 text-white py-3 px-6 rounded-full text-sm md:text-lg font-semibold shadow-md transition-transform transform hover:translate-y-1"
              className="sticky bottom-5 text-center mb-8 cursor-pointer inline-block bg-[#20606D] text-white py-3 px-6 rounded-full text-sm md:text-lg font-semibold shadow-md transition-transform transform hover:translate-y-1"
              // onClick={() => { setIsQuizStarted(false); quizStarted(); }}
              onClick={() => {
                setIsQuizStarted(false);
                // gtag("event", "start_assessment_click", {
                //   event_category: "engagement",
                //   event_label: "start_your_free_assessment_button",
                //   value: 1,
                // });
                gtag({
                  event: "start_weight_assessment_click",
                  data: {
                    event_category: "engagement",
                    event_label: "start_your_free_assessment_button",
                    value: 1,
                  },
                });
                window.newtag("event", "new_start_assessment_click", {
                  event_category: "engagement",
                  event_label: "new_start_your_free_assessment_button",
                  value: 1,
                });
                if (window.fbq) {
                  window.fbq("track", "Lead", {
                    quiz: "weight_quiz",
                    status: "started",
                  });
                }
              }}
            >
              {/* <a href="https://assessment.thehealthspanco.com" className="inline-block bg-orange-600 text-white py-3 px-6 rounded-full text-lg font-semibold shadow-md transition-transform transform hover:translate-y-1"> */}
              Start Your Free Assessment
              {/* </a> */}
            </div>

            <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 my-8">
              {[
                {
                  imgSrc: "assets/u1.jpeg",
                  name: "Rajesh S.",
                  testimonial:
                    "The personalized approach made all the difference. Lost 10 kg in 3 months following my custom plan!",
                },
                {
                  imgSrc: "assets/u2.jpeg",
                  name: "Anita P.",
                  testimonial:
                    "Finally found a sustainable way to manage my weight. No more yo-yo dieting!",
                },
                {
                  imgSrc: "assets/u3.jpeg",
                  name: "Sunil K.",
                  testimonial:
                    "The insights about my habits were eye-opening. Making small changes led to big results.",
                },
              ].map((testimonial, index) => (
                <div
                  key={index}
                  className="bg-white flex flex-col gap-3 text-center items-center md:items-start md:text-start p-6 rounded-lg shadow transition-transform transform hover:translate-y-1"
                >
                  <img
                    src={testimonial.imgSrc}
                    alt={testimonial.name}
                    className="w-20 h-20 rounded-full  mb-4"
                  />
                  <p className="font-semibold ">{testimonial.name}</p>
                  <p className="text-md">{testimonial.testimonial}</p>
                </div>
              ))}
            </section>
          </main>

          {/* <footer className="bg-gradient-to-r bg-[#2d3d23]  text-white text-center p-6 mt-12 flex flex-col items-center gap-2"> */}
          <footer className="bg-gradient-to-r bg-[#20606D]  text-white text-center p-6 mt-12 flex flex-col items-center gap-2">
            <h2 className="text-2xl font-bold">
              Ready to Transform Your Health?
            </h2>
            <p className="my-2">
              Join thousands who've discovered their path to lasting weight
              management
            </p>
            <div
              // onClick={() => setIsQuizStarted(false)}
              onClick={() => {
                setIsQuizStarted(false);
                // gtag("event", "start_assessment_click", {
                //   event_category: "engagement",
                //   event_label: "start_your_free_assessment_button",
                //   value: 1,
                // });
                gtag({
                  event: "start_weight_assessment_click",
                  data: {
                    event_category: "engagement",
                    event_label: "start_your_free_assessment_button",
                    value: 1,
                  },
                });
                  if (window.fbq) {
                  window.fbq("track", "Lead", {
                    quiz: "weight_quiz",
                    status: "started",
                  });
                }
              }}
              // className="inline-block bg-orange-600 text-white py-3 px-6 rounded-full text-sm cursor-pointer md:text-md sticky md:relative bottom-5 md:bottom-0 md:text-lg font-semibold shadow-md transition-transform transform hover:translate-y-1"
              // className="inline-block bg-[#2d3d23] text-white py-3 px-6 rounded-full text-sm cursor-pointer md:text-md sticky md:relative bottom-5 md:bottom-0 md:text-lg font-semibold shadow-md transition-transform transform hover:translate-y-1"
              className="inline-block bg-[#2d3d23] text-white py-3 px-6 rounded-full text-sm cursor-pointer md:text-md sticky md:relative bottom-5 md:bottom-0 md:text-lg font-semibold shadow-md transition-transform transform hover:translate-y-1"
            >
              Take the Free Quiz Now
            </div>
            <div className="flex relative justify-center gap-2 mt-4 opacity-90 text-sm">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className="w-4 h-5 absolute top-0 -left-1 md:-left-5"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
              <span>
                Your information is protected by industry-leading encryption
              </span>
            </div>
          </footer>
        </div>

        {/* ----------------------------------------------------------------------------------------------------------------------------------- */}
        {/* ----------------------------------------------------------------------------------------------------------------------------------- */}
      </div>
    </>
  );
};
